import CarouselSliderPlantas from "./CarouselSliderPlantas";

export default CarouselSliderPlantas;
